// extracted by mini-css-extract-plugin
export default {"menuOption":"dropdown-menu_menuOption__0Zo7U"};